// «واتساب ميتا (الرسمي)» as a send channel on every page that offers SMS / واتس تلقائي / اداة المتصفح / واتس مباشر.
// The pages call their own send('meta') → /user/messages/send-arr {method: 'meta'} (or the page's other route with
// method meta); the server refuses it with code 'meta_not_ready' when Meta is not ready (the page shows the error).
// Before that, the shared state below locks the option: the school sees it with a lock and, on a click, a dialog that
// sends it to «واتساب ميتا» (/_whatsapp/meta) to activate it.
//   metaState()     → Promise of the shared state (POST /user/whatsapp/meta/ready, cached 60 s, one request at a time)
//   metaLocked()    → true unless the last answer said ready (also while unknown, and on an old server: 404)
//   openMetaLock(vm)→ the «واتساب ميتا غير مفعّل» dialog
//   metaPick(vm)    → Promise<boolean>: ready → true; else the dialog and false (what the global components use)
//   metaWatch(router) (main.js) → asks again when the school comes back from «واتساب ميتا» or from another tab
// Global components (main.js): <meta-send-button> (the visible «واتساب ميتا» button next to SMS / إشعار الجوال),
// <meta-send-item> (pages whose send choices are only a dropdown), <meta-method-option> + <meta-method-hint>
// (send-method settings). Styles: src/assets/scss/meta-channel.scss. Same look and behaviour as the school app.
import Vue from 'vue'

// the send buttons / items, and the choice in the send-method settings
export const META_BUTTON = 'واتساب ميتا'
export const META_LABEL = 'واتساب ميتا (الرسمي)'
export const META_PAGE = '/_whatsapp/meta'
export const META_LOCK_TITLE = 'واتساب ميتا غير مفعّل'
export const META_LOCK_TEXT = 'الإرسال عبر واتساب ميتا (الرسائل الرسمية) يحتاج تفعيل الخدمة وربط رقمك أولاً. فعّلها من صفحة واتساب ميتا.'

const TTL = 60 * 1000
// an old server (no /ready, 404) or no answer: ask again much later, quietly
const TTL_OLD = 10 * 60 * 1000

// reactive: the components re-render when it changes
const state = Vue.observable({
  loaded: false,
  ready: false,
  enabled: false,
  connected: false,
  subscription_valid: false,
  // the reply said enabled / connected / subscription_valid (the dialog's three steps)
  has_steps: false,
  old: false,
})
let at = 0
let pending = null

function jwt() {
  try {
    var u = JSON.parse(localStorage.getItem('user'))
    return u && u.jwt
  } catch (e) {
    return null
  }
}

function put(x) {
  state.ready = !!x.ready
  state.enabled = !!x.enabled
  state.connected = !!x.connected
  state.subscription_valid = !!x.subscription_valid
  state.old = !!x.old
  state.has_steps = !!x.has_steps
  state.loaded = true
  at = Date.now()
}

export function metaState(force) {
  if (pending) return pending
  if (!force && state.loaded && Date.now() - at < (state.old ? TTL_OLD : TTL)) return Promise.resolve(state)
  var t = jwt(), $ = window.$
  if (!t || !$ || !window.api) {
    put({})
    return Promise.resolve(state)
  }
  pending = new Promise(function (resolve) {
    $.ajax({
      url: window.api + '/user/whatsapp/meta/ready',
      method: 'POST',
      data: { jwt: t },
      dataType: 'json',
      timeout: 15000,
      // not a page request: no «expired» redirect, no other global hook
      global: false,
    })
      .done(function (r) {
        // {status:100, ready, …} — at the top or in `response`
        var x = r && r.response && typeof r.response == 'object' ? r.response : r || {}
        if (!r || r.status != 100) x = {}
        // «تفعيل الخدمة»: `activated` when the server says it, else `enabled` (as the school app)
        put({ ready: x.ready, enabled: 'activated' in x ? x.activated : x.enabled, connected: x.connected, subscription_valid: x.subscription_valid,
          has_steps: 'enabled' in x || 'activated' in x || 'connected' in x || 'subscription_valid' in x })
      })
      .fail(function (xhr) {
        // 404: a server without the route yet → locked, asked again in 10 minutes (no error shown)
        put({ old: !xhr || xhr.status == 404 || xhr.status == 0 })
      })
      .always(function () {
        pending = null
        resolve(state)
      })
  })
  return pending
}

// drop the cache: the next metaState() asks the server (after a save on «واتساب ميتا», or a 'meta_not_ready')
export function metaForget() {
  at = 0
}

export function metaLocked() {
  return !state.ready
}

export function metaStateNow() {
  return state
}

function go(vm) {
  var r = vm && vm.$router
  if (r) {
    if (r.currentRoute && r.currentRoute.path == META_PAGE) return
    r.push(META_PAGE).catch(function () {})
  } else {
    window.location.href = META_PAGE
  }
}

let open = false
// the dialog = the school app's sheet: a tinted box with a lock and the text, then (when /ready said them)
// the three steps «تفعيل الخدمة» / «ربط رقم الواتساب» / «اشتراك ساري», then «فتح صفحة واتساب ميتا» / «إغلاق»
export function openMetaLock(vm) {
  if (!vm || !vm.$bvModal) {
    if (window.confirm(META_LOCK_TITLE + '\n' + META_LOCK_TEXT + '\n\nفتح صفحة واتساب ميتا؟')) go(vm)
    return Promise.resolve(false)
  }
  if (open) return Promise.resolve(false)
  open = true
  var h = vm.$createElement
  var parts = [
    h('div', { class: 'mc-lock-box' }, [
      h('span', { class: 'mc-lock-ico' }, [h('feather-icon', { props: { icon: 'LockIcon', size: '22' } })]),
      h('p', { class: 'mc-lock-text' }, META_LOCK_TEXT),
    ]),
  ]
  if (state.has_steps) {
    parts.push(
      h('ul', { class: 'mc-steps' }, [
        ['تفعيل الخدمة', state.enabled],
        ['ربط رقم الواتساب', state.connected],
        ['اشتراك ساري', state.subscription_valid],
      ].map(function (x) {
        return h('li', { class: x[1] ? 'done' : 'todo' }, [
          x[1]
            ? h('span', { class: 'mc-step-ico' }, [h('feather-icon', { props: { icon: 'CheckCircleIcon', size: '20' } })])
            : h('span', { class: 'mc-step-ico mc-step-dash' }),
          h('span', { class: 'mc-step-name' }, x[0]),
          h('span', { class: 'mc-step-state' }, x[1] ? 'تم' : 'مطلوب'),
        ])
      }))
    )
  }
  return vm.$bvModal
    .msgBoxConfirm([h('div', { class: 'mc-lock-body' }, parts)], {
      title: META_LOCK_TITLE,
      okTitleHtml: '<i class="fa fa-external-link"></i> فتح صفحة واتساب ميتا',
      cancelTitle: 'إغلاق',
      okVariant: 'primary',
      cancelVariant: 'outline-secondary',
      centered: true,
      modalClass: 'mc-lock-modal',
      footerClass: 'mc-lock-foot',
      hideHeaderClose: false,
    })
    .then(function (ok) {
      open = false
      if (ok) go(vm)
      return false
    })
    .catch(function () {
      open = false
      return false
    })
}

// a click on a Meta option: ready → true (send); otherwise read the state again (it may have been activated since,
// in another tab) and, still not ready, the lock dialog → false
export function metaPick(vm) {
  if (state.loaded && state.ready && Date.now() - at < TTL) return Promise.resolve(true)
  var fresh = state.loaded && Date.now() - at < 10 * 1000
  return metaState(!fresh && !state.old).then(function (s) {
    if (s.ready) return true
    openMetaLock(vm)
    return false
  })
}

// back from «واتساب ميتا» (route change, main.js) or from another tab while locked: ask again
export function metaWatch(router) {
  if (router && router.afterEach) {
    router.afterEach(function (to, from) {
      if (from && from.path == META_PAGE && to.path != META_PAGE) metaForget()
    })
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState != 'visible' || !state.loaded || state.ready || state.old) return
    if (Date.now() - at < 10 * 1000) return
    metaState(true)
  })
}
